import { InAppNotificationType } from '@interfaces';
import { foreignerNotificationRegistry } from './notifications.registry.foreigner';
import { managerNotificationRegistry } from './notifications.registry.manager';
import { staffNotificationRegistry } from './notifications.registry.staff';
import {
  NotificationAutoReadTarget,
  NotificationDefinition,
  NotificationRegistry,
} from './notifications.registry.types';

export const notificationRegistry: NotificationRegistry = {
  ...foreignerNotificationRegistry,
  ...staffNotificationRegistry,
  ...managerNotificationRegistry,
};

export const getNotificationDefinition = (
  notificationType: InAppNotificationType
): NotificationDefinition | undefined => {
  return notificationRegistry[notificationType];
};

export const notificationNonClickableTypes = Object.entries(notificationRegistry)
  .filter(([, definition]) => definition.clickableOverride === false)
  .map(([notificationType]) => notificationType as InAppNotificationType);

const getAutoReadTypes = (target: NotificationAutoReadTarget): InAppNotificationType[] => {
  return Object.entries(notificationRegistry)
    .filter(([, definition]) => definition.autoReadOn?.includes(target))
    .map(([notificationType]) => notificationType as InAppNotificationType);
};

export const cvmCandidateVerificationAutoReadTypes = getAutoReadTypes('cvm-details');
export const managerCandidateVerificationAutoReadTypes = getAutoReadTypes('manager-details');
export const summaryAutoReadTypes = getAutoReadTypes('summary');
export const myWorkPermitAutoReadTypes = getAutoReadTypes('my-work-permit');
export const workPermitModalAutoReadTypes = getAutoReadTypes('work-permit-modal');
